const GRAPHEME_SEGMENTER =
    typeof Intl !== 'undefined' && Intl.Segmenter
        ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
        : null;

const toGraphemes = function (text) {
    if (GRAPHEME_SEGMENTER) {
        return Array.from(GRAPHEME_SEGMENTER.segment(text)).map((s) => s.segment);
    }
    return Array.from(text);
};

const insertBetweenCharacters = function (word, separator) {
    if (!separator || !word) {
        return word;
    }
    return toGraphemes(word).join(separator);
};

/**
 * Inserts inner text between the characters and/or words of the given text.
 * Works like prefix/suffix but applied inside the text instead of wrapping it.
 * Must be applied to the buyer's core text, before prefix/suffix are added.
 * @param {string} text core text to transform
 * @param {string} betweenCharacters separator inserted between each character of every word (eg: "·" => F·R·I·E·N·D·S)
 * @param {string} betweenWords separator that replaces the whitespace between words (eg: " ❤︎ " => Hally ❤︎ Robbin)
 * @returns {string}
 */
export const applyInnerText = function (text, betweenCharacters, betweenWords) {
    if (!text || (!betweenCharacters && !betweenWords)) {
        return text;
    }

    return text
        .split('\n')
        .map((line) =>
            line
                .split(/(\s+)/)
                .map((token) => {
                    if (!token) {
                        return token;
                    }
                    if (/^\s+$/.test(token)) {
                        return betweenWords || token;
                    }
                    return insertBetweenCharacters(token, betweenCharacters);
                })
                .join('')
        )
        .join('\n');
};
